module.exports = __webpack_public_path__ + "static/media/Androidscreenshoot.680af54b.png";